import SweetAlert from "./components/SweetAlert";

export default SweetAlert;
